export class UIEntryUrlParameterController {
    static readonly DEFAULT_PARAMETER_VALUE = '1'
}
